import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["numberInput"];

  increase() {
    let count = parseInt(this.numberInputTarget.value) || 0;
    this.numberInputTarget.value = count + 1;
    this.numberInputTarget.dispatchEvent(new Event("change"));
  }

  decrease() {
    let count = parseInt(this.numberInputTarget.value) || 0;
    count = count > 1 ? count - 1 : 1;
    this.numberInputTarget.value = count;
    this.numberInputTarget.dispatchEvent(new Event("change"));
  }
}
